module.exports = __webpack_public_path__ + "images/ic-arrow-right-white.svg";